import ConfirmPrompt from '@shared/ui/Prompt/ConfirmPrompt.tsx';
import { useAppDispatch, useAppSelector } from '@store/hooks.ts';
import { t } from 'i18next';
import { memo } from 'react';
import { useNavigate } from 'react-router';

import { closeConfirmPrompt, pendingConfirmPrompt } from './globalConfirmPromptSlice.ts';

const GlobalConfirmPrompt = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isOpen, title, message, isLoading, buttons, module, redirectPath, fallbackPath } =
    useAppSelector(state => state.globalConfirmPrompt);

  const confirmText = buttons?.confirm || t('controls.confirm');
  const cancelText = buttons?.cancel || t('controls.cancel');

  const handleConfirm = () => {
    if (module === 'login' && redirectPath) {
      // Store the intended path for after login
      sessionStorage.setItem('redirectAfterLogin', redirectPath);
      dispatch(closeConfirmPrompt());
      // Use replace: true to avoid adding login page to history when coming from a protected route
      navigate('/login', { replace: true });
    } else {
      dispatch(pendingConfirmPrompt());
    }
  };

  const handleCancel = () => {
    if (module === 'login' && fallbackPath) {
      // Navigate back to a safe location (home or previous page)
      navigate(fallbackPath, { replace: true });
    }
    dispatch(closeConfirmPrompt());
  };

  return (
    <ConfirmPrompt
      openModal={isOpen}
      title={title}
      message={message}
      confirmText={confirmText}
      cancelText={cancelText}
      processingText={t('controls.processing')}
      isLoading={isLoading}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
};
export default memo(GlobalConfirmPrompt);
